function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u4E0A\\u50B3",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.3183331,15.2480665 L10.719258,14.5504212 C11.5961898,13.0244821 13.2605066,12 15.1666667,12 C17.5540232,12 19.5621184,13.6097621 20.115406,15.7847936 L20.3892134,16.8611617 L21.5077145,17.0289766 C22.7299608,17.212357 23.6666667,18.2504546 23.6666667,19.5 C23.6666667,20.8807122 22.5249931,22 21.1166667,22 L10.0666667,22 C8.18889842,22 6.66666667,20.5076157 6.66666667,18.6666667 C6.66666667,17.0117167 7.89851841,15.6356326 9.51224946,15.3771718 L10.3183331,15.2480665 Z",
  id: "file-/-cloud_up",
  fill: "#E89A4F"
}), /*#__PURE__*/React.createElement("g", {
  id: "file-/-cloud_up"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "file-/-cloud_up-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,13 L12,9 L16,13 L13.4499998,13 L13.4499998,16 L10.5500002,16 L10.5500002,13 L8,13 Z M12,4 C15.7484589,4 18.894783,6.57805037 19.7626076,10.0577888 C22.1620731,10.4249945 24,12.4978609 24,15 C24,17.7614241 21.7614231,20 19,20 L6,20 C2.68629146,20 0,17.3137083 0,14 C0,11.0181799 2.17514133,8.54439116 5.02528524,8.07877207 C6.39696312,5.64419317 9.00647068,4 12,4 C14.4989726,4 14.4989726,4 12,4 Z M5.34774446,10.0526061 L6.29607821,9.89767981 L6.76775455,9.06050539 C7.79943895,7.22937846 9.75745869,6 12,6 C14.8086548,6 17.1711197,7.93171453 17.8220463,10.5417523 L18.1441727,11.8333941 L19.4600563,12.0347719 C20.8979931,12.2548285 22,13.5005455 22,15 C22,16.6568546 20.6568546,18 19,18 L6,18 C3.79086089,18 2,16.2091389 2,14 C2,12.01406 3.44923735,10.3627591 5.34774446,10.0526061 L5.34774446,10.0526061 Z",
  fill: "#282C34",
  mask: "url(#mask-2)"
})));

function SvgSidebarUploadB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E0A\u50B3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUploadB);
export default __webpack_public_path__ + "static/media/sidebar_upload-b.5d5def3a.svg";
export { ForwardRef as ReactComponent };